import React from "react";

export const IconAddPhoto = () => (
  <svg
    width="74"
    height="59"
    viewBox="0 0 74 59"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.7141 14.7619C11.7141 10.8821 13.2553 7.1613 15.9987 4.41791C18.7421 1.67452 22.4629 0.133301 26.3427 0.133301C30.2224 0.133301 33.9433 1.67452 36.6866 4.41791C39.43 7.1613 40.9713 10.8821 40.9713 14.7619C40.9713 18.6416 39.43 22.3624 36.6866 25.1058C33.9433 27.8492 30.2224 29.3904 26.3427 29.3904C22.4629 29.3904 18.7421 27.8492 15.9987 25.1058C13.2553 22.3624 11.7141 18.6416 11.7141 14.7619ZM0.742676 55.2533C0.742676 43.9962 9.86268 34.8762 21.1198 34.8762H31.5655C42.8227 34.8762 51.9427 43.9962 51.9427 55.2533C51.9427 57.1276 50.4227 58.6476 48.5484 58.6476H4.13696C2.26268 58.6476 0.742676 57.1276 0.742676 55.2533ZM58.3427 35.7904V28.4762H51.0284C49.5084 28.4762 48.2855 27.2533 48.2855 25.7333C48.2855 24.2133 49.5084 22.9904 51.0284 22.9904H58.3427V15.6762C58.3427 14.1562 59.5655 12.9333 61.0855 12.9333C62.6055 12.9333 63.8284 14.1562 63.8284 15.6762V22.9904H71.1427C72.6627 22.9904 73.8855 24.2133 73.8855 25.7333C73.8855 27.2533 72.6627 28.4762 71.1427 28.4762H63.8284V35.7904C63.8284 37.3104 62.6055 38.5333 61.0855 38.5333C59.5655 38.5333 58.3427 37.3104 58.3427 35.7904Z"
      fill="black"
    />
  </svg>
);
